module.exports = __webpack_public_path__ + "img/MemberCard1.6acb376d.jpg";